/**
 * Every operation in flight when the session expired comes back flagged, so
 * the handler runs once for all of them.
 */
const SESSION_EXPIRED_COOLDOWN_MS = 30_000

interface SessionExpiredHandlerDeps {
  /** Drops the signed-in user, so the app shows a guest right away. */
  resetUser: () => void
  /** Resolves `false` when the user has to sign in again. */
  restoreSession: () => Promise<boolean>
  notifyExpired: () => void
}

export const createSessionExpiredHandler = ({
  resetUser,
  restoreSession,
  notifyExpired
}: SessionExpiredHandlerDeps) => {
  let lastRunAt = -Infinity

  return async () => {
    if (Date.now() - lastRunAt < SESSION_EXPIRED_COOLDOWN_MS) return
    lastRunAt = Date.now()

    resetUser()

    if (!(await restoreSession())) notifyExpired()
  }
}
